import React from "react";
import { ChildrenElements } from "../globalTypes";
import {
    Container,
    FormLabel
} from "@chakra-ui/react";

export function ScreenContainer(
    props: {
        children?: ChildrenElements;
    }
): JSX.Element {
    return (
        <Container maxW={'5xl'} {...props} >
            {props.children}
        </Container>
    );
}